module.exports = __webpack_public_path__ + "img/tank.f45049ee.png";